<template>
    <a class="btn btn-secondary mb-2" :href="route_back">Вернуться</a>
    <div>
        <div>
            <span class="fs-3">
                Контент плейлиста "{{item.name}}":
            </span>
            <div v-for="(playlist, index) in playlists" class="card" style="width: 18rem;">
                <div v-if="playlist.active">
                    <div class="card-body">
                        <h5 class="card-title">{{playlist.name}}</h5>
                        <a href="" class="btn btn-danger" v-on:click="deletePlaylist(index)">Удалить</a>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <span class="fs-3">
                Контент не добавленный:
            </span>
            <div v-for="(playlist, index) in playlists" class="card" style="width: 18rem;">
                <div v-if="!playlist.active">
                    <div class="card-body">
                        <h5 class="card-title">{{playlist.name}}</h5>
                        <a href="" class="btn btn-success" v-on:click="addPlaylist(index)">Добавить</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Group from "../../../../models/Group";

export default {
    name: "GroupPlaylistComponent",
    props: {
        route_back: String,
        route_get: String,
        route_playlist_add: String,
        route_playlist_del: String,
        item_id: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            group: new Group({
                route_get: this.route_get,
                route_playlist_add: this.route_playlist_add,
                route_playlist_del: this.route_playlist_del,
            }),
            item: {},
            playlists: []
        }
    },
    methods: {
        getObject: async function () {
            let response = await this.group.get(this.item_id);
            this.item = response.group;
            this.playlists = response.playlists;
        },
        addPlaylist: async function (index) {
            event.preventDefault();
            let result = await this.group.addPlaylist(this.item_id, this.playlists[index].id);
            if(result)
            {
                this.playlists[index].active = true;
            }
            else
            {
                console.log('error: playlist_add');
            }
        },
        deletePlaylist: async function (index) {
            event.preventDefault();
            let result = await this.group.delPlaylist(this.item_id, this.playlists[index].id);
            if(result)
            {
                this.playlists[index].active = false;
            }
            else
            {
                console.log('error: playlist_del');
            }
        }
    },
    mounted() {
        this.getObject();
    }
}
</script>

<style scoped>

</style>
